import React, { FC } from 'react';
import { LoginResult } from './actions/user-sign-in';
import { QRCode } from './qr-code';
import { OtpInput } from './otp-input';

interface OtpSetupVerify {
    otpResult: LoginResult;
    username: string;
    password: string;
    tokenSuccess: () => void;
}

export const OtpSetupVerify: FC<OtpSetupVerify> = (props) => {
    const { otpResult, username, password, tokenSuccess } = props;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {otpResult.uri && <>
                <div>
                    {/* current user language unknown at this time */}
                    <div>Please scan the qr code with an authenticator application.</div>
                    <div>When complete enter the 6 digit code to complete initial setup.</div>
                </div>
                <QRCode uri={otpResult.uri} />
            </>}
            <OtpInput
                username={username}
                password={password}
                tokenSuccess={tokenSuccess}
            />
        </div>
    );
};
